export const Pallate =  {
    priamry: "#31B28E",
    secondary: "#58C3A5", 
    white: "#FFFFFF", 
    black: "#000000", 
    gray: "#707070", 
    background: "#F5F5F5"
}